export default "__VITE_ASSET__BBQBg1JI__"